export default {
  intro_title: 'Help om ons Tour de France shirt te kiezen',
  intro_button: 'Start',

  cta_button: 'Stem op je favoriete shirt',

  hero_switch_dark: 'donker',
  hero_switch_light: 'licht',

  story_subtitle: 'Team Visma | Lease a Bike',
  story_title: 'The Architect',
  story_text_line1: 'Geïnspireerd door Gaudí en de spirit van Barcelona.',
  story_text_line2: 'Verbonden door de honingraat.',
  story_text_line3: 'Klaar om te bouwen aan succes.',

  customize_title: 'Truly make it your own',
  customize_text: 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',

  training_kit_title: 'Our official training kit',
  training_kit_text: 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.',
  training_kit_button: 'Pre-Order training kit',

  countdown_days: 'dagen',
  countdown_hours: 'uur',
  countdown_minutes: 'minuten',

  vote_title: 'Kies ons 2026 Tour de France shirt',
  vote_text: 'Jouw stem telt.',
  vote_percentage: 'van de stemmen',
  vote_success_title: 'Dank je wel!',
  vote_success_text: 'Je stem is opgeslagen. We maken het winnende shirt binnenkort bekend!',
  vote_form_subtitle_favorite: 'Kies je favoriet',
  vote_form_subtitle_confirm: 'Bevestig je keuze',
  vote_form_button_dark: 'Kies donker',
  vote_form_button_light: 'Kies licht',
  vote_form_firstname_label: 'Voornaam',
  vote_form_firstname_placeholder: 'Vul je voornaam in',
  vote_form_email_label: 'E-mail',
  vote_form_email_placeholder: 'Vul je e-mail in',
  vote_form_terms_label: 'Ik ga akkoord met de <a href="/files/NL_Actievoorwaarden_The_Architect_Team_Visma_Lease_a_Bike.pdf" target="_blank">algemene voorwaarden</a>',
  vote_form_marketing_label: 'Ja, ik ontvang graag interessante acties van partners van Team Visma | Lease a Bike en/of derden',
  vote_form_submit_button: 'Stem verzenden',
  vote_form_error_jersey: 'Selecteer een shirt.',
  vote_form_error_required: 'Dit veld is verplicht.',
  vote_form_error_email_invalid: 'Voer een geldig e-mailadres in.',
  vote_form_error_missing_parameters: 'Vul alle verplichte velden in.',
  vote_form_error_invalid_email: 'Voer een geldig e-mailadres in.',
  vote_form_error_something_went_wrong: 'Er ging iets mis. Probeer het opnieuw.',

  vote_done_title: 'Dankjewel voor het stemmen!',
  vote_done_text: 'Ons nieuwe Tour de France-shirt wordt spoedig bekend gemaakt.',
};
